exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-backdrop.show {\n  opacity: 0.2 !important;\n}\n.Same {\n  color: gray;\n}\n.LateCheckout,\n.EarlyCheckin {\n  color: red;\n}\n.LateCheckin,\n.EarlyCheckout {\n  color: green;\n}\n", ""]);

// exports
